<template>
    <rkm-modal
        extraLarge
        ref="Modal"
        title="Parametrização de cota de exame"
    >
        <Form
            :data="data"
            :index="index"
            :item="item"
            @save="handleExit"
            @checkHandleAlter="checkHandleAlter"
            ref="Form"
        />

         <template v-slot:footer="{ cancel }" v-if="!alter">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="handleSave"
                color="primary"
            >
                {{ index == null ? 'Incluir' : 'Alterar' }}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, object, data, mask, formats } from '@/mixins'

export default {
    components: { Form },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('exameLaboratorial.parametrizacao')
        }
    },
    data: () => ({
        index: null,
        item: null,
        alter: false
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(index, item) {

            this.index = index
            this.item = item

            if (index == null ) {

                this.$refs.Modal.show()
            } else if (item.alterado) {

                this.$refs.Modal.show()
            } else {

                this.getCotaExame(item)
            }
        },
        handleExit(data) {

            this.$emit('save', data)

            this.$refs.Modal.hide()
        },
        handleSave() {

            this.$refs.Form.save()
        },
        checkHandleAlter(value) {

            this.alter = value
        },
        getCotaExame(item) {

            this.setLoading()

            let inicio = item.inicio
            let fim = item.fim

            this.repositories.parametrizacao.getCotaExame({
                infraestrutura_id: item.infraestruturaId,
                cota_tipo_id: item.tipoId,
                inicio: this.getFormatedDate(inicio, 'YYYY-MM-DD', 'DD/MM/YYYY'),
                fim: this.getFormatedDate(fim, 'YYYY-MM-DD', 'DD/MM/YYYY'),
            })
                .then(response => {

                    const objId = this.data.model.cotasExamePeriodo.findIndex((obj =>
                        obj.id == item.id));

                    this.data.model.cotasExamePeriodo[objId].exames = response.data
                    this.data.model.cotasExamePeriodo[objId].alterado = true

                    this.data.model.cotasExamePeriodo.push()

                    this.$refs.Modal.show()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [ repository, object, data, mask, formats ],
    props: {
        data: { type: Object, required: true },
    }
}
</script>